export enum OnboardingModalSteps {
    GET_STARTED_STEP = 0,
    RESTAURANTS_STEP = 1,
    PLAY_AND_CONNECT_STEP = 2,
    DPAY_STEP = 3,
    DEALS_STEP = 4,
}
